export const TABS = [['overview', 'Overview'], ['rules', 'Rules'], ['clubs', 'Clubs'], ['stores', 'Stores Still Invalid'], ['invalid', 'Clubs Needing Mapping'], ['changes', 'Changes'], ['codisto', 'Codisto']];
const IDS = new Set(TABS.map(([id]) => id));
export const parseTab = (param) => (param && IDS.has(param) ? param : null);
export const tabPath = (id) => `/klaviyo-profile-cleanup/${id}`;
